import { useState, useEffect, useContext } from "react";
import AppContext from "../../context"
import css from "./ReportSerial.module.css"
import Card from "../../components/Card/Card"
import backgroundCard from "../../assets/images/background_image_1.png"
import { FaSortDown, FaSortUp } from "react-icons/fa"
import ExcelUtils from "../../utils/excel"
import { AlertEntity } from "../../layouts/Alert/AlertEntity"
import { format, formatDate } from "date-fns"
import filterUtils from "../../utils/filter-utils"
import { GrPowerReset } from "react-icons/gr"
import { NetstatData } from "../../entities/NetstatSerial"
import TableObserved from "../../components/Observer/tableRowsObserved"
import { SerialService } from "../../services/serial";

export default function ReportSerial() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext)
    const contextAccessToken = context.contextAccessToken
    const contextShowAlertFunc = context.contextShowAlertFunc
    const contextShowLoadingFunc = context.contextShowLoadingFunc
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //
    const [tableData, setTableData] = useState<NetstatData[]>([])
    const [tableDataCache, setTableDataCache] = useState<NetstatData[]>([])
    const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({})

    const [sortColumnChoosed, setSortColumnChoosed] = useState<keyof NetstatData | null>(null)
    const [sortColumnType, setSortColumnType] = useState<"ascending" | "descending">("ascending")

    const [filterDate, setFilterDate] = useState<{ start_date: Date, end_date: Date }>({ start_date: new Date(), end_date: new Date() })
    // ========================================= STATE VIEW =========================================  //


    // ====================================== SORT AND FILTER =======================================  //
    const handleFilterAndSort = () => {
        const table_filtered = tableDataCache.filter((row) => {
            return filterUtils.FilterTable(row, tableDataFilter)
        }).sort((a, b) => {
            if (!sortColumnChoosed) { return 0 }
            if (sortColumnType == "ascending") {
                return filterUtils.SortingTable(a, b, sortColumnChoosed)
            } else {
                return filterUtils.SortingTable(b, a, sortColumnChoosed)
            }
        })
        setTableData(table_filtered)
    }
    const filterTable = (column: keyof NetstatData, columnnName?: string) => {
        return <div>
            <input className="input-filter" type="text" value={tableDataFilter[column] ?? ""}
                placeholder={`${columnnName ?? column} ...`}
                onChange={(event) => {
                    setTableDataFilter((prev) => {
                        const newData = { ...prev }
                        newData[column] = event.target.value
                        return newData
                    })
                }}
            />
        </div>
    }
    const headerTable = (column: keyof NetstatData, columnName?: string) => {
        return <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "3px", whiteSpace: "nowrap", cursor: "pointer" }}
            onClick={() => {
                setSortColumnChoosed(column)
                if (sortColumnType === "ascending") {
                    setSortColumnType("descending")
                } else {
                    setSortColumnType("ascending")
                }
            }}
        >
            <div>{columnName ?? column}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "0", alignItems: "center", justifyItems: "center" }}>
                <FaSortUp style={{ color: ((sortColumnChoosed == column && sortColumnType == "descending") ? "var(--secondary-color)" : "silver"), margin: 0, padding: 0, height: '18px' }} />
                <FaSortDown style={{ color: ((sortColumnChoosed == column && sortColumnType == "ascending") ? "var(--secondary-color)" : "silver"), margin: "-18px", padding: 0, height: '18px' }} />
            </div>
        </div>
    }
    useEffect(() => {
        handleFilterAndSort()
    }, [tableDataFilter, sortColumnChoosed, sortColumnType])
    // ====================================== SORT AND FILTER =======================================  //


    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //
    const handleGenerateExcel = async () => {
        if (tableData.length == 0) { return contextShowAlertFunc({ message: "NO DATA!", level: 3 }) }
        const column = [
            "netstat_id", "netstat", "netstat_type", "customer", "po_number",
            "line_number", "serial_number", "generated_by", "created_at"
        ]
        let values: { [key: string]: string }[] = []
        for (let i = 0; i < tableData.length; i++) {
            values.push({
                netstat_id: `${tableData[i].netstat_id}`,
                netstat: tableData[i].netstat,
                netstat_type: tableData[i].netstat_type,
                customer: tableData[i].customer,
                po_number: tableData[i].po_number,
                line_number: tableData[i].line_number,
                serial_number: tableData[i].serial_number,
                generated_by: tableData[i].generated_by,
                created_at: formatDate(tableData[i].created_at, "yyyy-MM-dd HH:mm:ss")
            })
        }
        ExcelUtils.export(
            `Netstat List on ${format(filterDate.start_date, "yyyy-MM-dd")} to ${format(filterDate.end_date, "yyyy-MM-dd")}`,
            column, values,
        )
    }

    const generateData = async () => {
        contextShowLoadingFunc(true)
        try {
            const start_date = formatDate(filterDate.start_date, "yyyy-MM-dd")
            const end_date = formatDate(filterDate.end_date, "yyyy-MM-dd")

            const resp = await SerialService.GetSerialReport(start_date, end_date)
            setTableData(resp)
            setTableDataCache(resp)
            contextShowLoadingFunc(false)
        } catch (error: any) {
            contextShowAlertFunc({ message: error.message, level: 3 })
            contextShowLoadingFunc(false)
        }
    }

    useEffect(() => {
        generateData()
    }, [contextAccessToken])
    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return <>
        <div className="master-container">
            {/* Card Header */}
            <div className="header-wrapper ordering-card">
                <Card
                    detailTitle="Report Netstat Serial"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={<>
                        <div className={css.rowGrid} style={{ marginBottom: "16px" }}>
                            <div>
                                <label className="label-header">Start Date</label>
                                <input
                                    className="input-date-header"
                                    value={filterDate?.start_date ? format(filterDate?.start_date, "yyyy-MM-dd") : undefined}
                                    placeholder="Choose Date" type="date"
                                    onChange={(event) => {
                                        setFilterDate((prevState) => {
                                            return ({
                                                ...prevState,
                                                start_date: new Date(event.target.value)
                                            })
                                        })
                                    }}
                                />
                            </div>
                            <div>
                                <label className="label-header">End Date</label>
                                <input
                                    className="input-date-header"
                                    value={filterDate?.end_date ? format(filterDate?.end_date, "yyyy-MM-dd") : undefined}
                                    placeholder="Choose Date" type="date"
                                    onChange={(event) => {
                                        setFilterDate((prevState) => {
                                            return ({
                                                ...prevState,
                                                end_date: new Date(event.target.value)
                                            })
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className={css.rowGrid}>
                            <div>
                                <button className="btn-card" onClick={() => handleGenerateExcel()} >
                                    Generate Excel
                                </button>
                            </div>
                            <div>
                                <button className="btn-card" onClick={() => { setTableDataFilter({}); generateData(); }} >
                                    <GrPowerReset /> &nbsp; Refresh
                                </button>
                            </div>
                        </div>
                    </>}
                />
            </div>

            {/* Table */}
            <div className="table-wrapper ordering-table">
                <table className="tableclickcell">
                    <thead>
                        <tr>
                            <th>
                                {headerTable("netstat_id", "Netstat Id")}
                                {filterTable("netstat_id", "Netstat Id")}
                            </th>
                            <th>
                                {headerTable("netstat", "Netstat")}
                                {filterTable("netstat", "Netstat")}
                            </th>
                            <th>
                                {headerTable("netstat_type", "Netstat Type")}
                                {filterTable("netstat_type", "Netstat Type")}
                            </th>
                            <th>
                                {headerTable("customer", "Customer")}
                                {filterTable("customer", "Customer")}
                            </th>
                            <th>
                                {headerTable("po_number", "PO Number")}
                                {filterTable("po_number", "PO Number")}
                            </th>
                            <th>
                                {headerTable("line_number", "Line Number")}
                                {filterTable("line_number", "Line Number")}
                            </th>
                            <th>
                                {headerTable("serial_number", "Serial Number")}
                                {filterTable("serial_number", "Serial Number")}
                            </th>
                            <th>
                                {headerTable("generated_by", "Generated By")}
                                {filterTable("generated_by", "Generated By")}
                            </th>
                            <th>
                                {headerTable("created_at", "Created At")}
                                {filterTable("created_at", "Created At")}
                            </th>
                        </tr>
                    </thead>
                    {tableData.length > 0
                        ? <tbody>
                            <TableObserved<NetstatData>
                                tableData={tableData}
                                rowFunction={function (index, row): JSX.Element {
                                    return <>
                                        <td>{row.netstat_id}</td>
                                        <td>{row.netstat}</td>
                                        <td>{row.netstat_type}</td>
                                        <td>{row.customer}</td>
                                        <td>{row.po_number}</td>
                                        <td>{row.line_number}</td>
                                        <td>{row.serial_number}</td>
                                        <td>{row.generated_by}</td>
                                        <td>{formatDate(row.created_at, "yyyy-MM-dd HH:mm:ss")}</td>
                                    </>
                                }}
                                rowsCount={250}
                                rowsIncrement={50}
                            />
                        </tbody>
                        : <tbody><tr><td colSpan={1000}>No Data Available Yet !</td></tr></tbody>
                    }
                </table>
            </div>
        </div>
    </>
}
